import { render, staticRenderFns } from "./CardStudentInfo.vue?vue&type=template&id=21f60422&scoped=true&"
import script from "./CardStudentInfo.vue?vue&type=script&lang=js&"
export * from "./CardStudentInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardStudentInfo.vue?vue&type=style&index=0&id=21f60422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f60422",
  null
  
)

export default component.exports